import { useContext } from 'react'
import context, { ContextProviderValue } from 'utils/context'

export const useAppContext = (): ContextProviderValue => {
  return useContext(context)
}
